import { configureStore } from "@reduxjs/toolkit";

import { User } from "../types/user";
import authReducer, * as auth from "./authSlice";
import workspaceReducer from "./workspaceSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    workspace: workspaceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const initStore = (rootEl: HTMLElement) => {
  const user: User | null = JSON.parse(rootEl.dataset.user);
  if (user !== null) {
    store.dispatch(auth.setUser(user));
    store.dispatch(auth.checkUser());
  }
};
